let changeLoginType = {
    type: 'changeLoginType',
    payload: {}
}
export {changeLoginType}